module.exports = __webpack_public_path__ + "static/media/3_community.06de0834.jpg";